import React, { useState } from 'react';

// Dummy data for illustration
const deadlines = [
  { id: 1, title: "Early Decision Deadline", date: "2024-11-01", urgency: "critical" },
  { id: 2, title: "CSS Profile Due", date: "2025-11-01", urgency: "upcoming" },
];
const requirements = [
  { label: "Essays", value: 2 },
  { label: "Teacher Recs", value: 2 },
  { label: "Counselor Rec", value: "✓" },
  { label: "Interview", value: "Optional" },
];
const stats = [
  { label: "Overall Rate", value: "5.1%" },
  { label: "ED Rate", value: "8.1%" },
  { label: "Yield", value: "54%" },
  { label: "Tuition", value: "$65k" },
];

const sections = [
  { key: "priorities", label: "Immediate Priorities" },
  { key: "value", label: "Your Value Proposition" },
  { key: "research", label: "Strategic Research" },
  { key: "notes", label: "Other Notes" },
];

export default function CollegeStrategyMockup() {
  const [openSection, setOpenSection] = useState("priorities");

  return (
    <div className="flex flex-col lg:flex-row gap-8 p-8 bg-slate-50 min-h-screen">
      {/* Sidebar */}
      <aside className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-6">
        <div className="bg-white rounded-xl border p-4">
          <h3 className="font-semibold text-slate-900 mb-2">Key Deadlines</h3>
          <ul className="space-y-2">
            {deadlines.map(dl => (
              <li key={dl.id} className="flex justify-between text-sm">
                <span>{dl.title}</span>
                <span className={`font-medium ${dl.urgency === "critical" ? "text-red-600" : "text-slate-600"}`}>
                  {new Date(dl.date).toLocaleDateString()}
                </span>
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-white rounded-xl border p-4">
          <h3 className="font-semibold text-slate-900 mb-2">Requirements</h3>
          <ul className="space-y-1 text-sm">
            {requirements.map(req => (
              <li key={req.label} className="flex justify-between">
                <span>{req.label}</span>
                <span className="font-medium">{req.value}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-white rounded-xl border p-4">
          <h3 className="font-semibold text-slate-900 mb-2">Quick Actions</h3>
          <div className="flex flex-col gap-2">
            <button className="bg-azure-50 text-azure-700 rounded px-3 py-2 text-sm">+ Add Deadline</button>
            <button className="bg-emerald-50 text-emerald-700 rounded px-3 py-2 text-sm">+ Add Task</button>
            <button className="bg-indigo-50 text-indigo-700 rounded px-3 py-2 text-sm">+ Add Essay</button>
          </div>
        </div>
        <div className="bg-white rounded-xl border p-4">
          <h3 className="font-semibold text-slate-900 mb-2">Stats</h3>
          <ul className="space-y-1 text-sm">
            {stats.map(stat => (
              <li key={stat.label} className="flex justify-between">
                <span>{stat.label}</span>
                <span className="font-medium">{stat.value}</span>
              </li>
            ))}
          </ul>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col gap-6">
        {sections.map(section => (
          <section key={section.key} className="bg-white rounded-xl border">
            <button
              className="w-full flex justify-between items-center p-5 text-left focus:outline-none"
              aria-expanded={openSection === section.key}
              onClick={() => setOpenSection(section.key)}
            >
              <span className="text-lg font-semibold text-slate-900">{section.label}</span>
              <span className="text-slate-500">{openSection === section.key ? "−" : "+"}</span>
            </button>
            {openSection === section.key && (
              <div className="p-5 border-t">
                {/* Replace below with real content for each section */}
                {section.key === "priorities" && (
                  <div>
                    <p className="text-slate-700 mb-2">Your next 1-2 actions go here (e.g., "Request Recommendations", "Draft Why Duke Essay").</p>
                  </div>
                )}
                {section.key === "value" && (
                  <div>
                    <label className="block text-sm font-medium mb-1">Your Interests</label>
                    <textarea className="w-full border rounded p-2 mb-3" rows={3} placeholder="What are you passionate about?" />
                    <label className="block text-sm font-medium mb-1">Your Experiences</label>
                    <textarea className="w-full border rounded p-2 mb-3" rows={3} placeholder="What unique experiences do you bring?" />
                    <label className="block text-sm font-medium mb-1">Your Perspectives</label>
                    <textarea className="w-full border rounded p-2" rows={3} placeholder="What perspectives will you add?" />
                  </div>
                )}
                {section.key === "research" && (
                  <div>
                    <label className="block text-sm font-medium mb-1">Strategic Research Notes</label>
                    <textarea className="w-full border rounded p-2" rows={5} placeholder="Specific programs, opportunities, faculty, etc." />
                  </div>
                )}
                {section.key === "notes" && (
                  <div>
                    <label className="block text-sm font-medium mb-1">Other Notes</label>
                    <textarea className="w-full border rounded p-2" rows={3} placeholder="Anything else to remember?" />
                  </div>
                )}
              </div>
            )}
          </section>
        ))}
      </main>
    </div>
  );
}